var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.componentClasses},[_c('span',{staticClass:"new-navigation-submenu-list__title"},[_vm._t("title")],2),_vm._t("list")],2)}
var staticRenderFns = []

export { render, staticRenderFns }